import { ManageAccountsOutlined } from "@mui/icons-material";
import { Chip, Link, Stack, SxProps, Tooltip, Typography, useTheme } from "@mui/material";
import { LinkBehavior } from "../../../../components";
import { Links } from "../../../../constants";
import { useBreakpoints } from "../../../../hooks";
import { useTeamPageLayoutContext } from "../TeamPageLayout";

interface IProps {
  showAdministratorsTooltip?: boolean;
  sx?: SxProps;
}

const TeamTitle = (props: IProps) => {
  const { team } = useTeamPageLayoutContext();
  const { isMdUp } = useBreakpoints();
  const theme = useTheme();

  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "end", ...props.sx }}>
      <Stack spacing={0.25} sx={{ pb: 0, overflow: "hidden" }}>
        {team.parentTeam && (
          <Chip
            label={team.parentTeam.name}
            color="primary"
            size="small"
            component={LinkBehavior}
            href={Links.Team(team.parentTeam.slug)}
            clickable
          />
        )}
        <Typography variant="h3" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {team.name}
        </Typography>
      </Stack>

      {props.showAdministratorsTooltip && isMdUp && (
        <Tooltip
          title={
            <Stack>
              <Typography variant="caption" sx={{ color: theme.palette.text.primary, fontWeight: 700 }}>
                Administrators
              </Typography>
              {team.administrators
                .sort((a, b) => a.displayName.localeCompare(b.displayName))
                .map((u, i) => (
                  <Link key={i} href={Links.User(u.userId)}>
                    <Typography variant="caption" sx={{ color: theme.palette.primary.main }}>
                      {u.displayName}
                    </Typography>
                  </Link>
                ))}
            </Stack>
          }
          placement="bottom-start"
          disableTouchListener={team.administrators.length === 0}
          disableHoverListener={team.administrators.length === 0}
        >
          <Chip icon={<ManageAccountsOutlined />} label="Admins" sx={{ mb: "5px !important" }} />
        </Tooltip>
      )}
    </Stack>
  );
};

export { TeamTitle };
